 (function () {
  const originalScrollIntoView = Element.prototype.scrollIntoView;

  Element.prototype.scrollIntoView = function (...args) {
    const activeElement = document.activeElement;

    const isTriggeredBySearchInput = activeElement &&
      activeElement.matches &&
      activeElement.matches('.content-for-layout .template-search__search .search__input.field__input');

    if (this.tagName === 'MAIN-SEARCH' && isTriggeredBySearchInput) {
      return; // Block scroll
    }

    return originalScrollIntoView.apply(this, args);
  };

})();
// this is for blocking behaviour of scroll when ajax seach field inside main-content section

jQuery(document).ready(function($){
    // Select the dynamically generated success message
    var $success = $('.newsletter-form__message--success');
  $success.prepend('<span class="newsletter-close">&times;</span>');
    // Only run if it exists
    if($success.length){
        // Add a close button dynamically        

        
        // Show the popup
        $success.addClass('active');

        // Close button click
        $(document).on('click', '.newsletter-form__message--success .newsletter-close', function(){
            $(this).closest('.newsletter-form__message--success').removeClass('active');
        });

        // Optional: close on ESC key
        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                $('.newsletter-form__message--success').removeClass('active');
            }
        });
    }
});


/*jQuery(document).ready(function($) { 
  var $menu = $('#HeaderMenu-MenuList-2');

  // Add has-submenu class where needed
  $menu.find('.header__menu-item').each(function() {
    var $this = $(this);
    if ($this.next('.header__submenu').length > 0) {
      $this.addClass('has-submenu');
      $this.next('.header__submenu').hide(); // ensure it's hidden initially
    }
  });

  // Toggle submenu visibility
  $menu.on('click', '.header__menu-item.has-submenu', function(e) {
    e.preventDefault();
    var $this = $(this);
    var $submenu = $this.next('.header__submenu');

    if ($submenu.is(':visible')) {
      $submenu.stop(true, true).slideUp(200, function() {
        this.style.setProperty('display', 'none', 'important'); // force hide
      });
      $this.removeClass('active');
    } else {
      // Remove the !important restriction dynamically
      $submenu.each(function() {
        this.style.setProperty('display', 'block', 'important');
      });
      $submenu.stop(true, true).hide().slideDown(200, function() {
        this.style.setProperty('display', 'block', 'important'); // ensure visible
      });
      $this.addClass('active');
    }
  });
});*/

jQuery(document).ready(function($) { 
  var $menu = $('#HeaderMenu-MenuList-2');

  // Add has-submenu class where needed
  $menu.find('.header__menu-item').each(function() {
    var $this = $(this);
    if ($this.next('.header__submenu').length > 0) {
      $this.addClass('has-submenu');
      $this.next('.header__submenu').hide(); // ensure it's hidden initially
    }
  });

  // Toggle submenu visibility
  $menu.on('click', '.header__menu-item.has-submenu', function(e) {
    e.preventDefault();
    var $this = $(this);
    var $submenu = $this.next('.header__submenu');

    // ✅ Close all other submenus first
    $menu.find('.header__menu-item.active').not($this).each(function() {
      var $other = $(this);
      var $otherSubmenu = $other.next('.header__submenu');
      $otherSubmenu.stop(true, true).slideUp(200, function() {
        this.style.setProperty('display', 'none', 'important');
      });
      $other.removeClass('active');
    });

    // Toggle current submenu
    if ($submenu.is(':visible')) {
      $submenu.stop(true, true).slideUp(200, function() {
        this.style.setProperty('display', 'none', 'important');
      });
      $this.removeClass('active');
    } else {
      $submenu.each(function() {
        this.style.removeProperty('display'); // reset inline display
      });
      $submenu.stop(true, true).hide().slideDown(200, function() {
        this.style.setProperty('display', 'block', 'important');
      });
      $this.addClass('active');
    }
  });
});
